var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFnTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-social-media-logo-icon 1",
    clipPath: "url(#clip0_1691_961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3872 0H3.61281C1.61751 0 0 1.625 0 3.62954V12.3705C0 14.375 1.61751 16 3.61281 16H12.3872C14.3825 16 16 14.375 16 12.3705V3.62954C16 1.625 14.3825 0 12.3872 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1168 4.65723H11.2456L8.77965 7.48903L11.6806 11.3421H9.40902L7.62996 9.00539L5.59402 11.3421H4.46465L7.10215 8.31345L4.31934 4.65723H6.6484L8.25652 6.79332L10.1168 4.65723ZM9.72059 10.6633H10.3462L6.30871 5.3005H5.63746L9.72059 10.6633Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1691_961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnTwitter);
export default __webpack_public_path__ + "static/media/fn-twitter.60aef8ba2662f773a1265923b450875d.svg";
export { ForwardRef as ReactComponent };